import React from "react";
import PocDasboardSurveyAssessmentView from "../../components/dashboard/PocDasboardSurveyAssessmentView";
// import { ORG_POC_SURVEY_LIST,ORG_SURVEY_BY_ID } from "modules/poc-dashboard/graphql/pocDashboardQuery.gql";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { ORG_POC_VERTICAL_GRAPH_DATA } from "modules/poc-dashboard/graphql/organizationQuery.gql";
import { getSurveyBase64StringFromInt } from "modules/look";
import { getOrgID } from "../organization/organizationOperations";

const PocDashboardAssessmentContainer = (props) => {
    const { client, me, org_survey_list, orgToFetchData } = props
    const [verticals_assessment_data, setVerticalAssessmentData] = React.useState()
    const [data_list_loading, setDataListLoading] = React.useState(false)
    React.useEffect(() => {
        if (me?.employee && org_survey_list?.length > 0) {
            let survey_id = localStorage.getItem("poc_report_survey_id")
            let selected_survey
            if (survey_id) {
                selected_survey = org_survey_list?.find(i => i?.id === getSurveyBase64StringFromInt(survey_id))
            }
            if (getOrgID(props) || orgToFetchData?.id) {
                verticalAssessmentData({ id: getOrgID(props) || orgToFetchData?.id, survey_id: selected_survey?.id || org_survey_list[0]?.id })
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [me, org_survey_list, orgToFetchData])
    const parseObject = (str) => {
        return JSON.parse(str.replace(/'/g, '"'));
    };
    const verticalAssessmentData = async (filter) => {
        setDataListLoading(true)
        const { data } = await client.query({
            query: ORG_POC_VERTICAL_GRAPH_DATA,
            variables: { ...filter },
            fetchPolicy: 'network-only'
        });
        if (data?.organizationById) {
            setVerticalAssessmentData(data?.organizationById?.surveySet?.edges[0]?.node?.summaryListByVertical?.map(parseObject))
            setDataListLoading(false)
        }
    }

    return (
        <>
            <PocDasboardSurveyAssessmentView
                verticals_assessment_data={verticals_assessment_data}
                getVerticalAssessmentData={(filter) => verticalAssessmentData(filter)}
                data_list_loading={data_list_loading}
                {...props} />
        </>
    )
}

export default compose(withApollo)(PocDashboardAssessmentContainer)